import useTextAreaOrInputState from '@anm/hooks/useTextAreaOrInputState';
import { useSelector } from 'react-redux';

import { hostedVideoSelectors } from '../../../store/modules/hostedVideo';
import useProjectData from '../useProjectData';

const useStreamTitle = (projectId?: string) => {
  const videoName = useSelector(hostedVideoSelectors.selectVideoName);
  const { projectName } = useProjectData(projectId);

  const defaultName = videoName || projectName || (projectId ? 'Add title' : '');

  const [title, handleTitleChange, , setTile] = useTextAreaOrInputState(defaultName);

  return [title, handleTitleChange, setTile] as const;
};

export default useStreamTitle;
